const defaultTheme = {
	darkGrey: '#404040',
	lightGrey: '#E3E3E3',
	white: '#ffffff',

	defaultShadow: '2px 2px 15px 10px rgba(0,0,0,0.06)',
	defaultBorderRadius: '5px',
};

export { defaultTheme as default };
